import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createModule = data => post(url.CREATE_MODULE, data);
export const updateModule = data => put(url.UPDATE_MODULE, data);
export const deleteModule = id => del(url.DELETE_MODULE + id);
export const fetchAllModuleOfCourse = data => post(url.FETCH_ALL_MODULE__OF_COURSE, data);
export const fetchSingleModule = id => get(url.FETCH_SINGLE_MODULE + id);

const fetchCourseModules = async (courseId) => {
    try {
        // Using your existing module helper with POST
        const data = await fetchAllModuleOfCourse({ id: courseId });
        if (data?.success) {
            // Initialize modules with default status (first module unlocked)
            const modules = data?.result || [];
            const modulesWithStatus = modules.map((module, index) => ({
                ...module,
                status: index === 0 ? 'UNLOCK' : 'LOCK',
                progress: null
            }));
            return modulesWithStatus;
        }
        return [];
    } catch (error) {
        console.log("Error fetching modules:", error);
        return [];
    }
};
